import { create } from 'zustand'

type Theme = 'light' | 'dark'

const STORAGE_KEY = 'octapos.theme'

function initialTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'light' || stored === 'dark') return stored

  // Light by default everywhere — the login screen, the platform panel and the till. A phone
  // browser's dark-mode preference is usually set for reading at night, not for a shop counter
  // in daylight, so it is no longer taken as a hint here; anyone who wants dark still gets it,
  // one tap away, and it's remembered from then on.
  return 'light'
}

function apply(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

interface ThemeState {
  theme: Theme
  toggle: () => void
  set: (theme: Theme) => void
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: 'light',

  toggle: () => get().set(get().theme === 'dark' ? 'light' : 'dark'),

  set: (theme) => {
    apply(theme)
    localStorage.setItem(STORAGE_KEY, theme)
    set({ theme })
  },
}))

/** Applied before first paint in main.tsx so the app never flashes the wrong theme. */
export function initTheme(): void {
  const theme = initialTheme()
  apply(theme)
  useTheme.setState({ theme })
}
